<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="card-body">
                  <div class="pb-0 text-start">
                    <h4 class="font-weight-bolder">Ingresar</h4>
                    <p class="mb-0">Ingrese su uaurio y contraseña</p>
                  </div>
                  <br />
                  <form role="form">
                    <div class="mb-3">
                      <input
                        type="text"
                        class="form-control lg"
                        v-model="usuario"
                        name="usuario"
                        id="usuario"
                        placeholder="usuario"
                      />
                    </div>
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <input
                          :type = "verpassword ? 'password' : 'text'"
                          class="form-control lg"
                          v-model="password"
                          name="password"
                          id="password"
                          placeholder="password"
                        />
                        <span class="input-group-text"
                          ><i type="button" class="fa" 
                          :class="{ 'fa-eye-slash': verpassword, 'fa-eye': !verpassword }"
                           @click="verclave()"></i
                        ></span>
                      </div>
                    </div>
                   <div class="row">
                 <div class="col-md-12">
                  <h6><strong>Servicio Presentado</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="servicio_utilizar">
                      <option value="">Seleccionar Subservicio</option>
                   <option v-for="item in listaservicios" :value="item.id" :key="item.id">{{item.nombre_servicio}}</option>
                    </select>
                  </div>
                </div>
              </div>
                   <div class="row">
                 <div class="col-md-12">
                  <h6><strong>Modulo Presentado</strong></h6>
                  <div class="form-group">
                     <select class="form-select" v-model="modulo_utilizar">
                      <option value="">Seleccionar Modulo</option>
                   <option v-for="item in listamodulos" :value="item.codigo" :key="item.codigo">{{item.nombre}}</option>
                    </select>
                  </div>
                </div>
              </div>

                    <div class="text-center">
                      <a
                        type="button"
                        @click="login()"
                        class="btn-info btn-lg mb-0 gradient mt-4"
                        >Iniciar Session</a
                      >
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 position-absolute end-0 justify-content-center flex-column"
            >
              <img
              style="background-size: cover;"
                        src="../assets/images/loginimagen.png"
                        class="h-100 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                        alt="user image"
                      />
                <span class="mask opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >
                  SISTEMA DE TURNOS
                </h4>
                <p class="text-white position-relative">
                  Turnoro Digital para Optimizar el flujo del personal en sala,
                  reduzca los tiempos de espera, optener detallado en tiempo
                  real de sus oficinas.
                </p>
              <!-- </div> -->
            </div>
          </div>
           
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from "axios";
export default {
  name: "Home",
  components: {},
  data: function () {
    return {
      dialog: true,
      tab: 0,
      valid: true,
      usuario: "",
      password: "",
      verpassword: true,
      show1: false,
      token: "",
      listamodulos: "",
      listaservicios: "",
      servicio_utilizar: "",
      modulo_utilizar: "",
    };
  },
    created() {
    this.modulos_activos();
    this.servicios_activos();
  },
  methods: {
       modulos_activos() {
        axios.post("llamar_modulos")
          .then((respuesta) => {
            this.listamodulos = respuesta.data.filter(modulo => modulo.estado === 'A');
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
      servicios_activos() {
        axios.post("llamar_servicios_todos")
          .then((respuesta) => {
            this.listaservicios = respuesta.data.filter(servi => servi.estado === 'A');
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
    verclave() {
      this.verpassword = !this.verpassword;
    },
    login() {
      this.$swal.fire({
        // title: 'Auto close alert!',
        html: "Cargando por favor espere.",
        // timer: 2000,
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      const tokenpeticion = {
        usuario: this.usuario,
        password: this.password,
        servicio: this.servicio_utilizar,
        modulo: this.modulo_utilizar,
      };
      axios.post("login", tokenpeticion).then((respuesta) => {
        if (respuesta.data.status == true) {
          this.token = respuesta.data.token;
          const datos = respuesta.data;
          sessionStorage.setItem("token", this.token);
          sessionStorage.setItem("nivel", datos.nivel);
          localStorage.setItem("nombre", datos.nombres);
          localStorage.setItem("usuario", datos.usuario);
          localStorage.setItem("documento", datos.cedula);
          localStorage.setItem("modulo", datos.modulo_utilizar);
          localStorage.setItem("servicio", datos.servicio);
          localStorage.setItem("nombreservicio", datos.nombreservicio);
          // ===============================================================
          this.$swal.fire(
            "Bienvenido",
            "Session Iniciada Correctamente",
            "success"
          );
          var date = new Date();
          localStorage.setItem(
            "hora",
            date.setTime(date.getTime() + 8 * 60 * 60 * 1000)
          ); // asignar horas
          // localStorage.setItem("hora",date.getTime() + 30*60000); //asignar minutos
          this.$router.push({ path: "/inicio" });
        } else {
          this.$swal.fire("Ups!!", "Usuario o Contraseña Incorrectos", "error");
        }
      });
    },
  },
};
</script>
<style scoped>

</style>